import { useRef, type ReactNode } from 'react'
import { LightField } from '@/components/glass/LightField'
import { useLiquidLens } from '@/hooks/useLiquidLens'

interface CtaBannerProps {
  title: string
  subtitle?: string
  /** Il pulsante (o link) dell'invito. */
  action: ReactNode
}

/** Invito finale: una grande lente di vetro sopra la luce più intensa della pagina. */
export function CtaBanner({ title, subtitle, action }: CtaBannerProps) {
  const panelRef = useRef<HTMLDivElement>(null)
  const lens = useLiquidLens(panelRef, { radius: 40, depth: 26, strength: 90 })

  return (
    <section data-surface="dark" className="section overflow-clip">
      <LightField variant="surge" flow />
      <div className="shell">
        <div
          ref={panelRef}
          data-glow
          className="glass reveal mx-auto max-w-5xl px-6 py-16 text-center [--lens-blur:14px] [--radius:2.5rem] sm:px-12 md:py-24"
        >
          {lens}
          <h2 className="t-display mx-auto max-w-3xl">{title}</h2>
          {subtitle && <p className="t-lead mx-auto mt-6 max-w-2xl">{subtitle}</p>}
          <div className="mt-10 flex justify-center">{action}</div>
        </div>
      </div>
    </section>
  )
}
